module.exports = __webpack_public_path__ + "img/document.621733b1.svg";